import CurrentProduct from '@/modules/user-info/components/product/index.vue'
import {mapGetters, mapMutations, mapActions} from "vuex";

export default {
    name: 'user',
    components: {
        CurrentProduct
    },
    computed: {
        ...mapGetters({
            showPopUpUserExit: `auth/showPopUpUserExit`,
            isAuthenticated: 'auth/isAuthenticated',
            userData: 'userData/userInfo'
        }),
        showCurrentRoute() {
            switch (this.$route.name) {
                case 'current-order':
                    return this.$t('currentOrders')
                    break;
                case'userInfo':
                    return this.$t('userProfile')
                    break;
                case'history-orders':
                    return this.$t('historyOrders')
                    break;
            }

        },
    },
    created() {

    },
    methods: {
        ...mapMutations({
            changeShowPopUpExit: 'auth/CHANGE_POPUP_USER_EXIT',
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
        }),
        ...mapActions({})

    }
}
